import { RavelElement } from '../../ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';

export class RavelMStream extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #container {
            padding: 20px;
            margin: 20px;
            border: 4px solid #777777;
            border-radius: 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container">
        <div id="type">m-stream</div>
        <div id="name">Foo Bar</div>
        <div id="inputs">signal 1, signal 2</div>
        <div id="outputs">signal 3</div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'attribute'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        // e.g. this.icon = this.shadowRoot.querySelector('#icon');
    }
  
    setup = () => {
        this.observedMessages = ['message'];
        //this.subscribe(this.observedMessages);   
    }
    
    teardown = () => {
       // this.unsubscribe(this.observedMessages);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        
        if (name === 'attribute') {
            // Do something
        }
    }
}

